import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App.jsx";
import ThemeOneApp from "./theme1/ThemeOneApp.jsx";
import "./styles.css";
import "./theme1/theme-one.css";

const RootApp = import.meta.env.VITE_THEME_LAYOUT === "1" ? ThemeOneApp : App;

createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <RootApp />
  </React.StrictMode>
);
